export default "__VITE_ASSET__5wKlyco3__"